import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { LoaderService } from '../helpers/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests = 0; // Counter for active requests

  constructor(private loaderService: LoaderService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Increment request counter and show loader
    this.requests++;
    this.loaderService.show();

    return next.handle(request).pipe(
      // The tap operator allows you to perform side effects on the observable,
      // like logging or manipulating state, without affecting the values themselves.
      tap(
        (event) => {
          // You could inspect specific HTTP events here if needed,
          // e.g., only hide on HttpResponse, but finalize handles both success/error.
          if (
            event instanceof HttpResponse ||
            event instanceof HttpErrorResponse
          ) {
            // console.log('HTTP event received:', event.type);
          }
        },
        (error) => {
          // Handle HTTP errors here if necessary, before the final hide
          // console.error('HTTP error:', error);
        },
      ),
      // The finalize operator is called when the observable completes or errors,
      // ensuring the loader is hidden regardless of the outcome.
      finalize(() => {
        // Decrement request counter
        this.requests--;
        // Hide loader only when all requests are complete
        if (this.requests === 0) {
          this.loaderService.hide();
        }
      }),
    );
  }
}
